import React from 'react'
import { Alert, LayoutContentWrapper, LayoutPageWrapper } from 'goustouicomponents/dist'
import {
  Heading2,
  Join,
  Space,
} from '@gousto-internal/citrus-react'
import DOMPurify from 'dompurify'
import { ContentLoader } from '../ContentLoader'
import { createSlugFromUrl, removeHtmlTags } from '../../utils'
import { ArticlePreview } from '../ArticlePreview/ArticlePreview'
import { useFetchSectionArticles } from '../../hooks/useFetchSectionArticles'

interface SectionContentProps {
  id: string
}

const SectionContent = ({ id }: SectionContentProps) => {
  const {
    sectionArticlesError,
    isSectionArticlesFetching,
    sectionArticlesResponse,
  } = useFetchSectionArticles(id)

  const articles = sectionArticlesResponse?.articles

  if (isSectionArticlesFetching) {
    return <ContentLoader />
  }

  if (!articles?.length || sectionArticlesError) {
    return (
      <LayoutPageWrapper>
        <LayoutContentWrapper>
          <Alert type="danger">
            <Heading2 size={4}>Something went wrong!</Heading2>
            <p>There is an issue fetching the articles.</p>
          </Alert>
        </LayoutContentWrapper>
      </LayoutPageWrapper>
    )
  }

  return (
    <div>
      <Join
        with={<Space size={5} />}
      >
        {articles.map((article) => {
          const {
            id: articleId, name, html_url: htmlUrl, body,
          } = article

          const bodyWithoutTags = DOMPurify.sanitize(removeHtmlTags(body))

          const articleNameSlug = createSlugFromUrl(htmlUrl)

          return (
            <ArticlePreview
              key={articleId}
              id={articleId}
              description={bodyWithoutTags}
              nameSlug={articleNameSlug}
              name={name}
            />
          )
        })}
      </Join>
    </div>
  )
}

export { SectionContent }
